import { PxdAgGridColumnTypes, PxdAgGridDefaultColumnDef, PxdAgGridExcelStyles, PxdAgGridOptions, PxdAgGridSideBarOptions, PxdAgGridStatusBarOptions, PXDDefaultExcelExportParams } from '@app/shared/aggrid/pxd-ag-grid-options';

export const assetMappingPipelineGridOptions: PxdAgGridOptions = {
  enableCharts: true,
  cellSelection: true,
  rowGroupPanelShow: 'never',
  defaultColDef: PxdAgGridDefaultColumnDef,
  statusBar: PxdAgGridStatusBarOptions,
  sideBar: PxdAgGridSideBarOptions,
  columnTypes: PxdAgGridColumnTypes,
  excelStyles: PxdAgGridExcelStyles,
  defaultExcelExportParams: PXDDefaultExcelExportParams,
  rowSelection: { mode: 'multiRow', headerCheckbox: true, selectAll: 'all' },
  columnDefs: [
    { field: 'Ssn', type: ['textColumn'] },
    { field: 'AssetName', type: ['textColumn'] },
    { field: 'ActualDrillGroupReference', headerName: 'Drill Group ID' },
    { field: 'FieldDevelopmentArea', type: ['textColumn'] },
    { field: 'AreaTeam', type: ['textColumn'] },
    { field: 'IsJointVenture', headerName: 'JV Status', cellRenderer: params => params.value === true ? 'JV' : 'Non-JV' },
    { field: 'PutOnProductionDate', headerName: 'POP Date', type: ['dateColumn'], cellClass: 'ExcelDate' }
  ]
};

export const assetMappingPipelineSelectedGridOptions: PxdAgGridOptions = {
  enableCharts: true,
  cellSelection: true,
  rowGroupPanelShow: 'never',
  defaultColDef: PxdAgGridDefaultColumnDef,
  statusBar: PxdAgGridStatusBarOptions,
  sideBar: PxdAgGridSideBarOptions,
  columnTypes: PxdAgGridColumnTypes,
  excelStyles: PxdAgGridExcelStyles,
  defaultExcelExportParams: PXDDefaultExcelExportParams,
  rowSelection: { mode: 'multiRow' },
  columnDefs: [
    { field: 'AssetName', type: ['textColumn'] },
    { field: 'Ssn', type: ['textColumn'] },
    { field: 'ActualDrillGroupReference', headerName: 'Drill Group ID' },
    { field: 'FieldDevelopmentArea', type: ['textColumn'] },
    { field: 'AreaTeam', type: ['textColumn'] },
    { field: 'IsJointVenture', headerName: 'JV Status', cellRenderer: params => params.value === true ? 'JV' : 'Non-JV' },
    { field: 'PutOnProductionDate', headerName: 'POP Date', type: ['dateColumn'], cellClass: 'ExcelDate' }
  ]
};